<template>
  <span class="text-primary" style="cursor: pointer" @click.stop="navigate">
    <slot />
  </span>
</template>

<script>
export default {
  name: "HyperLink",
  props: {
    id: { required: true },
    supplier_id: { required: false, default: null },
    type: { required: true },
    step: { type: Number, default: 0 },
    open: { required: false, default: false, type: Boolean },
    newTab: { type: Boolean, default: true },
  },
  methods: {
    navigate() {
      let path = "";
      let query = {};

      if (this.id === null) {
        return;
      }
      switch (this.type) {
        case "supplier":
          path = `/pages/manage-nimble/suppliers/${this.id}`;
          break;
        case "sundry_supplier":
          path = `/pages/manage-nimble/suppliers/sundry/${this.id}`;
          break;

        case "customer":
          path = `/pages/manage-nimble/customers/${this.id}`;
          break;

        case "sundry":
          path = `/pages/sundry-items`;
          if (this.open) {
            query.open = this.id;
          }
          break;
        case "raw-material":
          path = `/pages/manage-nimble/suppliers/${this.supplier_id}/raw-material/${this.id}`;
          break;
        case "formulation":
          path = `/pages/formulations/${this.id}`;
          break;

        case "product-order":
          path = `/pages/product-orders/${this.id}`;
          break;
        case "work-order":
          path = `/pages/manufacturing/work-orders/${this.id}/details`;
          break;
        case "sundry-order":
          path = `/pages/sundry-items/orders/${this.id}`;
          break;
        case "production-code":
          path = `/pages/settings`;
          query = { tab: 'manufacturing fg_product_form', open: this.id };
          break;
        case "raw-material-order":
          path = `/pages/raw-materials/orders/${this.id}`;
          break;
        case "tasting-group":
          path = `/pages/taste-panels?open=${this.id}`;
          break;
        case "sales-quote":
          path = `/pages/sales-quote?id=${this.id}`;
          break;
        default:
          console.warn("Unknown type:", this.type);
          return;
      }

      const router = this.$router;

      if (router) {
        if (this.newTab) {
          const resolved = router.resolve({ path, query });
          window.open(resolved.href, "_blank");
        } else {
          router.push({ path, query });
        }
      } else {
        const url =
          query && Object.keys(query).length
            ? `${path}?${new URLSearchParams(query).toString()}`
            : path;

        if (this.newTab) {
          window.open(url, "_blank");
        } else {
          window.location.href = url;
        }
      }
    },
  },
};
</script>
